import Splide from '@splidejs/splide';
import './finanziamenti-slider.scss';

export class FinanziamentiSlider {
  constructor() {
    this.el = document.querySelector('.js-finanziamenti-slider');
    if (!this.el) return;

    this.init();
  }

  init() {
    const splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '24px',
      perPage: 3.2,
      focus: 0,
      destroy: false,
      drag: true,
      breakpoints: {
        992: {
          perPage: 2.2,
        },
        767: {
          perPage: 1.2,
        },
      },
    });

    splide.mount();

    const next = this.el.querySelector('.splide__arrow--next');
    const updateArrows = () => {
      if (!window.matchMedia('(min-width: 992px)').matches) return;
      const { index } = splide;
      const last = splide.length - splide.options.perPage;

      // Se sono all’ultima slide disabilito next
      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }
    };

    // primo chek al caricamento
    updateArrows();
    // secondo check al cambio slide
    splide.on('mounted move', updateArrows);
  }
}
